import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, Divider } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Close } from "@mui/icons-material";
import { closeModal } from "../../features/modal/modalSlice";

export default function Confirm({ fn }) {
    const { isSending } = useSelector(state => state.progress)
    const { openModalConfirm, item } = useSelector(state => state.modal);
    const dispatch = useDispatch();
    const close = () => dispatch(closeModal());
    const action = () => dispatch(fn);

    return (
        <Dialog open={openModalConfirm} onClose={close}>
            <DialogTitle>
                Eliminar registro?
                <IconButton
                    aria-label="close"
                    onClick={close}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: grey[500],
                    }}
                    >
                    <Close />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Typography align='center' variant='h5' color={'blue'} >{item}</Typography>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant='outlined' color="primary" onClick={close}>Cancelar</Button>
                <Button variant='outlined' disabled={isSending} color="secondary" onClick={action}>Eliminar</Button>
            </DialogActions>
        </Dialog>
      );       
}